import React, {useContext, useState, useEffect} from "react";
import moment from "moment";
//import { ProfileContext } from "../ProfileContext";
//import { ToastContainer } from 'react-toastify';
import { successMesg, errorMesg } from "../../../Toaster";
import { Modal, Button } from 'react-bootstrap';
import {UpdateOtherInfoAPI, getOtherProfileAPI} from "./../../../../API/Publisher/LeadAPI";


const OtherProfile = ({profiledata, profileid}) =>{

    //const {profiledata, profileid} = useContext(ProfileContext);
    const [isotherinfomodal, setIsOtherInfoModal] = useState(false);
    const [otheremail, setOtherEmail] = useState("");
    const [othercontact, setOtherContact] = useState("");
    const [disposition, setDisposition] = useState("");
    const [subdisposition, setSubdisposition] = useState("");
    const [designation, setDesignation] = useState("");
    const [lastupdated, setLastUpdated] = useState("");
    /*const [institute, setInstitute] = useState("");
    const [program, setProgram] = useState("");
    const [source, setSource] = useState("");
    const [createddate, setCreatedDate] = useState("");*/
    const [btnsubmitspin, setSubmitSpin] = useState(false);
    const [isupdateotherinfo, setIsUpdateOtherInfo] = useState(false);

    const txtotherinfomodalheader = "Update Lead Other Info";

    const handleOtherInfoModal = () =>{
		setIsOtherInfoModal(!isotherinfomodal);
	}

    useEffect(()=>{
        console.log('Other Info Data reloaded');
        getOtherProfileAPI(setOtherEmail, setOtherContact, setDesignation, profileid);
        
    }, [profileid]);

    useEffect(()=>{
        
        console.log('Step 2 Info Data reloaded');

        setOtherEmail(profiledata?.other_email || "");
        setOtherContact(profiledata?.alternate_contact || "");
        setDisposition(profiledata?.dispositionname || "");
        setSubdisposition(profiledata?.subdispositionname || "");
        //setProgram(profiledata?.basicinfo?.program || "");
        //setInstitute(profiledata?.basicinfo?.institute || "");
        //setSource(profiledata?.basicinfo?.source || "");
        setLastUpdated(profiledata?.updated_at || "");
        //setCreatedDate(moment(profiledata?.basicinfo?.created_at).format('DD MMM YYYY') || "");
        

    }, []);



    const handleOtherInfoModalHide = () =>{
        setIsOtherInfoModal(false);
    }

    const handleOtherEmail = (e) =>{
        setOtherEmail(e.target.value);
    }

    const handleOtherContact = (e) =>{
        setOtherContact(e.target.value);
    }

    const handleDesignation = (e) =>{
        setDesignation(e.target.value);
    }

    const handleOtherInfoSubmit = () =>{

        const formdata = new FormData();
        formdata.append('leadid', profileid);
        formdata.append('otheremail', otheremail);
        formdata.append('othercontact', othercontact);
        formdata.append('designation', designation);
        
        UpdateOtherInfoAPI(formdata, setSubmitSpin, setIsUpdateOtherInfo, setIsOtherInfoModal);
    }

    /*if(!profiledata)
        return null;*/

    return(
    <div className="col-xl-3 theiaStickySidebar">
        <div className="card">
            <div className="card-body p-3">
                <div className="row">
                    <div className="col-10">
                        <h6 className="mb-3 fw-semibold">Lead Information</h6>                                
                    </div>
                    <div className="col-2">
                        <button className="btn-none" onClick={handleOtherInfoModal}>
                            <i className="fas fa-pencil"></i>
                        </button>
                    </div>
                </div>
                <ul>
                    <li className="row mb-3">
                        <span className="col-6">Other Email</span>
                        <span className="col-6">{otheremail || ""}</span>
                    </li>
                    <li className="row mb-3">
                        <span className="col-6">Other Contact</span>
                        <span className="col-6">{othercontact || ""}</span>
                    </li>
                    {/*<li className="row mb-3">
                        <span className="col-6">Program</span>
                        <span className="col-6">{program}</span>
                    </li>
                    <li className="row mb-3">
                        <span className="col-6">Institute</span>
                        <span className="col-6">{institute}</span>
                    </li>*/}
                    <li className="row mb-3">
                        <span className="col-6">Disposition</span>
                        <span className="col-6">{disposition || ""}</span>
                    </li>
                    <li className="row mb-3">
                        <span className="col-6">Sub-Disposition</span>
                        <span className="col-6">{subdisposition || ""}</span>
                    </li>
                    {/*<li className="row mb-3">
                        <span className="col-6">Source</span>
                        <span className="col-6">{source}</span>
                    </li>
                    <li className="row mb-3">
                        <span className="col-6">Date Created</span>
                        <span className="col-6">{ moment(createddate).format('DD MMM YYYY') }</span>
                    </li>*/}
                    <li className="row mb-3">
                        <span className="col-6">Last Updated</span>
                        <span className="col-6">
                            {lastupdated !== "" && lastupdated !== null ?
                                (moment(lastupdated).format('DD MMM YYYY'))
                            :
                                <></>
                            }
                        </span>
                    </li>

                </ul>
            </div>

            <Modal show={isotherinfomodal} onHide={handleOtherInfoModalHide} centered>
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">{txtotherinfomodalheader}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="mb-3">
                        <label className="col-form-label">Other Email 
                            <span className="text-danger">*</span>
                        </label>
                        <input type="email" className="form-control" value={otheremail} onChange={handleOtherEmail} />
                    </div>
                    <div className="mb-3">
                        <label className="col-form-label">Other Contact 
                            <span className="text-danger">*</span>
                        </label>
                        <input type="text" className="form-control" value={othercontact} onChange={handleOtherContact} />
                    </div>
                    <div className="mb-3">
                        <label className="col-form-label">Designation 
                            <span className="text-danger">*</span>
                        </label>
                        <input type="text" className="form-control" value={designation} onChange={handleDesignation} />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" class="btn btn-cancel" data-bs-dismiss="modal" onClick={handleOtherInfoModalHide}>Close</button>

                    {btnsubmitspin ?
                        <button type="button" class="btn btn-primary"> 
                            <div className="spinner-border" role="status">
                                <span className="sr-only">Loading...</span>
                            </div>
                        </button>
                    :
                        <button type="button" class="btn btn-primary" onClick={handleOtherInfoSubmit}> Update Info </button>
                    }
                </Modal.Footer>
            </Modal>

        </div>
    </div>
    );
}

export default OtherProfile;
